import angular from 'angular'

angular.module("core.application.main").directive("core.application.main.directive.alphanumeric", function() {

    var expose = {};
    expose.require = "ngModel";
    expose.restrict = "A";

    // This directive validates for numbers and letters only:
    // For example:
    //     aC123456
    //     Hg654321
    //     1334DGDF343

    // Not allowed:
    //     Ac24 2343
    //     ∴a892ljaa
    //     *&23LKJ@@

    expose.link = function($scope, element, attributes, controller) {

        var validate = function(value) {
            value = value || "";
            if (! $scope.$eval(attributes.alphanumericDisabled)) {
                controller.$setValidity("format", value.match(/^[a-z0-9]+$/i) !== null);
            } else {
                // Clear out a potentially stale validity check if the directive is disabled dynamically
                controller.$setValidity("format", true);
            }
            return value;
        };

        attributes.$observe("alphanumericDisabled", function() {
            validate(controller.$viewValue);
        });

        controller.$parsers.unshift(validate);
        controller.$formatters.unshift(validate);
    };

    return expose;

});
